import { Auditable, FormSelectCategory, QueryParams, SortParams, FormData, FormType } from "..";

export interface FormHeaderFooterConfig {
    image: string;
    x: number;
    y: number;
    width: number;
    height: number;
    addressFontSize: number;
    lohAddressOffsetX: number;
    lohAddressOffsetY: number;
    asnAddressOffsetX: number;
    asnAddressOffsetY: number;
    caseNumFontSize: number;
    caseNumOffsetX: number;
    caseNumOffsetY: number;
    unosOffsetX: number;
    unosOffsetY: number;
    hasDonorNumber: boolean;
    hasIntentForEyes: boolean;
}

export interface FormEntity extends Auditable {
    name: string;
    formCategoryId?: number;
    tenantId: number;
    slug: string;
    version?: string;
    formConfig?: FormHeaderFooterConfig;
    formTypeId?: number;
    formType?: FormType;
    formCategory?: FormSelectCategory;
    editClaim?: string;
    signClaim?: string;
    approveClaim?: string;
    unlockClaim?: string;

    formData: FormData[];
}

export const DefaultFormQueryParams: QueryParams = {
    name: "",
    formCategoryId: "",
};

export const DefaultFormSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
